import { render, staticRenderFns } from "./artist-star-profile-detail.vue?vue&type=template&id=26cfc942&scoped=true"
import script from "./artist-star-profile-detail.vue?vue&type=script&lang=js"
export * from "./artist-star-profile-detail.vue?vue&type=script&lang=js"
import style0 from "./artist-star-profile-detail.vue?vue&type=style&index=0&id=26cfc942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cfc942",
  null
  
)

export default component.exports